import { ApiCatch } from "@/utils/decorators";
import { Api } from "../api.service";
import { SendAnswersDTO } from "~/dal/questionare";
export class QuestionareService {
  @ApiCatch
  static async getQuestionnaire() {
    const response = await Api.get("/dal/getQuestionnaire");
    return response.data;
  }

  @ApiCatch
  static async sendAnswers(req: SendAnswersDTO) {
    const response = await Api.post("/dal/sendAnswer", req);
    return response.data;
  }
}
